module.exports = (fox, $) => {
    return {
        getWidth() {
            return window.outerWidth;
        },

        getHeight() {
            return window.innerHeight;
        },

        isWidthUp(size, include) {
            const w = this.getWidth();

            return include ? w >= size : w > size;
        },

        isWidthDown(size, include) {
            const w = this.getWidth();

            return include ? w <= size : w < size;
        },

        getScrollY() {
            return window.scrollY;
        },

        listenResize(cb, timer) {
            let resizeInt;
            const clearInt = window.clearInterval;

            const _cb = (e) => {
                if (resizeInt) {
                    clearInt(resizeInt);
                }

                resizeInt = window.setTimeout(() => {
                    cb({
                        width: this.getWidth(),
                        height: this.getHeight()
                    }, e);
                }, (timer || 66)); // handler will execute at a rate of 15fps
            }
            

            window.addEventListener('resize', _cb);

            return () => {
                window.removeEventListener('resize', _cb);
                clearInt(resizeInt);
            }
        },

        listenScrollEnd(cb) {
            let isScrolling;
            const _cb = (e) => {
                // Clear our timeout throughout the scroll
                window.clearTimeout( isScrolling );
            
                // Set a timeout to run after scrolling ends
                isScrolling = setTimeout(function() {
            
                    // Run the callback
                    // console.log( 'Scrolling has stopped.' );
                    cb();
            
                }, 66);
            }


            window.addEventListener('scroll', _cb, false);

            return () => {
                window.removeEventListener('scroll', _cb);
                window.clearTimeout( isScrolling );
            }
        },

        scrollToBlock(selector, delta = 0) {
            const pos = $(selector).position();

            if (!pos) {
                this.scrollTo(0);

                return;
            }

            const num = Math.round(pos.top);

            this.scrollTo(num + delta);
        },

        scrollTo(point) {
            $('body, html').animate({scrollTop: point});
        },

        //https://stackoverflow.com/a/19690464
        isRetinaDisplay() {
            if (window.matchMedia) {
                var mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
                return (mq && mq.matches || (window.devicePixelRatio > 1)); 
            }
        },

        // https://stackoverflow.com/a/21164477
        isBlockInViewport(elem, fraction=0.9){
            var x = elem.offsetLeft, y = elem.offsetTop, w = elem.offsetWidth, h = elem.offsetHeight, r = x + w, //right
                b = y + h, //bottom
                visibleX, visibleY, visible;

            visibleX = Math.max(0, Math.min(w, window.pageXOffset + window.innerWidth - x, r - window.pageXOffset));
            visibleY = Math.max(0, Math.min(h, window.pageYOffset + window.innerHeight - y, b - window.pageYOffset));

            visible = visibleX * visibleY / (w * h);

            return (visible > fraction);
        }

    }
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/utils/window.es.js